// 商品リスト更新
function RenderProducts () {
	// まずはローディングを表示する

	document.getElementById( 'ClassificationForm' ).classList.add( 'loading' );
	document.querySelectorAll( '#ClassificationForm select' ).forEach( ( select ) => select.disabled = true );
	document.querySelectorAll( '.loading__spinner' ).forEach( ( spinner ) => spinner.classList.remove( 'hidden' ) );
	document.getElementById( 'ProductGridContainer' ).querySelector( '.collection' ).classList.add( 'loading' );

	// gridのセクション
	const section =  document.getElementById( 'product-grid' ).dataset.id;

	const requrl = `${ window.location.pathname }?section_id=${ section }&${ url.searchParams }`;

	console.log('requrl', requrl );

	fetch(requrl)
		.then( ( response ) => response.text() )
		.then( ( responseText ) => {
			document.getElementById( 'ProductGridContainer' ).innerHTML = new DOMParser()
				.parseFromString( responseText, 'text/html' )
				.getElementById( 'ProductGridContainer' ).innerHTML;
		})
		.finally(()=>{
			document.getElementById( 'ClassificationForm' ).classList.remove( 'loading' );
			document.querySelectorAll( '#ClassificationForm select' ).forEach( ( select ) => select.disabled = false );
			document.querySelectorAll( '.loading__spinner' ).forEach( ( spinner ) => spinner.classList.add( 'hidden' ) );
			document.getElementById( 'ProductGridContainer' ).querySelector( '.collection' ).classList.remove( 'loading' );
		});
};

// フォームのchangedイベント
function FilFormChanged () {
	url.searchParams.delete( 'filter.p.tag' );
	url.searchParams.delete( 'sort_by' );
	for ( let i = 0; i < classForm.elements.length; i++ ) {
		if ( classForm.elements[ i ].id == 'sort_by' ) {
			url.searchParams.append( 'sort_by', ( classForm.elements[ i ].value ) );
		} else if ( classForm.elements[ i ].value != '' ) {
			url.searchParams.append( 'filter.p.tag', ( classForm.elements[ i ].value ) );
		};
	}
	history.replaceState( null, null, url );
	RenderProducts();
}


// タグフィルタの実体フォーム
let classForm = document.querySelector( '#ClassificationForm' );
// 現在のURL
let url = new URL( window.location.href );

let filTagGroups = [];
filTags.forEach( ( tag ) => {
	let found = false;
	for ( let i = 0; i < filTagGroups.length; i++ ) {
		if ( filTagGroups[ i ].groupName === tag.split( '_' )[ 2 ] ) {
			filTagGroups[ i ].tags.push( { fullTag: tag, tagName: tag.split( '_' )[ 3 ] } );
			found = true;
			break;
		}
	}
	if ( !found ) {
		filTagGroups.push( { groupName: tag.split( '_' )[ 2 ], tags: [ { fullTag: tag, tagName: tag.split( '_' )[ 3 ] } ] } );
	}
} );

for ( let i = 0; i < filTagGroups.length; i++ ) {
	let div = document.createElement( 'div' );
	let label = document.createElement( 'label' );
	let select = document.createElement( 'select' );
	select.id = 'fil' + i;
	label.for = 'fil' + i;
	label.textContent = filTagGroups[ i ].groupName;
	let option = document.createElement( 'option' );
	option.value = '';
	option.textContent = '全て';
	select.append( option );
	filTagGroups[ i ].tags.forEach( ( tag ) => {
		let option = document.createElement( 'option' );
		option.value = tag.fullTag;
		option.textContent = tag.tagName;
		for ( let j = 0; j < url.searchParams.getAll( 'filter.p.tag' ).length; j++ ) {
			if ( tag.fullTag == decodeURI( url.searchParams.getAll( 'filter.p.tag' )[ j ] ) ) {
				option.selected = true;
			}
		}
		select.append( option );
	} );
	div.append( label );
	select.onchange = FilFormChanged;
	div.append( select );
	document.querySelector( '#ClassSelects' ).append( div );
}
classForm.append( document.createElement( 'p' ) );
if ( url.searchParams.getAll( 'sort_by' ) != '' ) {
	document.querySelector( '#sort_by' ).querySelector( 'option[value="' + url.searchParams.getAll( 'sort_by' ) + '"]' ).selected = true;
}
document.querySelector( '#sort_by' ).onchange = FilFormChanged;